import { AnyAction } from 'redux';
import * as constants from 'redux/constants/deaths.constants';
import { ITableUpdate } from 'types/table.types';
import { IDeathsFormData } from 'views/public/DeathsView/components/DeathsForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.DEATHS_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.DEATHS_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.DEATHS_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.DEATHS_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IDeathsFormData, id?: string): AnyAction => ({
  type: constants.DEATHS_ON_SAVE_REQUESTED,
  formData,
  id,
});
